import './assets/tailwind.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { config } from './config'
import { installStaleChunkReload } from './utils/staleChunkReload'

const app = createApp(App)

// Initialize Sentry
if (config.sentry.enabled) {
  Sentry.init({
    app,
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    sendDefaultPii: config.sentry.sendDefaultPii,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0 // 100% of sessions with errors
  })
}

// After a deploy the previous build's chunks are gone: reload once instead of
// leaving the user on a dead tab (see utils/staleChunkReload.ts).
installStaleChunkReload(router)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
